import { useEffect, useRef } from "react";

/** Returns a ref that auto-focuses its element on mount. */
export const useAutoFocus = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return ref;
};
